import SectionHeading from "@/components/base/SectionHeading";
import { westernPicks } from "@/mocks/content";

export default function WesternPicks() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <SectionHeading
        id="western"
        eyebrow="Western Blockbusters"
        title="欧美大片：注重视听体验的高规格制作"
        description="这一方向以商业大片为主，通常在画面、动作与特效上投入较大，也常见系列化与联动作品。如果你更看重沉浸式的视听体验，可以从这里开始浏览。"
      />

      <div className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
        {westernPicks.map((item) => (
          <article
            key={item.id}
            className="group rounded-lg overflow-hidden border border-background-200 bg-background-50 flex flex-col sm:flex-row transition-colors hover:border-primary-300"
          >
            <div className="w-full sm:w-48 shrink-0 h-44 sm:h-auto overflow-hidden bg-background-200">
              <img
                src={item.image}
                alt={`${item.title} 剧照`}
                title={`${item.title} 剧照`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-800 text-[11px]">
                  {item.meta}
                </span>
                <span className="text-xs text-foreground-500">{item.year}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-1 text-xs text-foreground-500">{item.original}</p>
              <p className="mt-3 text-sm leading-7 text-foreground-600 flex-1">{item.desc}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}